import { Component, OnInit } from '@angular/core';
import { SubheaderService } from '../../../../../core/services/layout/subheader.service';
import { MensagensService, ConfirmDialogOptions } from 'max-ng-lib';
import { LogoEmpresaService } from '../../../../../services/logo-empresa.service';

@Component({
  selector: 'm-logo-empresa',
  templateUrl: './logo-empresa.component.html',
  styleUrls: ['./logo-empresa.component.scss'],
})
export class LogoEmpresaComponent implements OnInit {

  modelo: any = {};
  carregou = false;

  constructor(
    public mensagens: MensagensService,
    public subheaderService: SubheaderService,
    public logoEmpresaService: LogoEmpresaService) {

    this.carregarLogoEmpresa();
  }

  private carregarLogoEmpresa() {
    this.logoEmpresaService.getLogoEmpresa()
      .subscribe(arquivo => {
        this.carregou = true;
        if (arquivo) {
          this.createImageFromBlob(arquivo);
        }
      });
  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.modelo.arquivo = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  ngOnInit() {

    this.subheaderService.setTitle('Logo da Empresa');
    this.subheaderService.setBreadcrumbs([
      { title: 'Logo da Empresa', page: '/pages/configuracoes/logo-empresa' },
    ]);
  }

  remover() {

    this.mensagens
      .exibaConfirmDialog('Deseja realizar a exclusão da imagem?', 'Remover a imagem')
      .subscribe(result => {
        if (result.confirmDialogSelect === ConfirmDialogOptions.SIM) {
          this.carregou = false;

          // .post('logoEmpresa/excluir')
          this.logoEmpresaService.excluirLogo()
            .subscribe(() => {

              this.modelo = {};
              this.carregou = true;
              this.mensagens.exibaToastSucesso('Imagem excluída com sucesso!');
              this.carregarLogoEmpresa();
            }, error => {
              this.carregou = true;
            });
        }
      });
  }
}
